import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAutoApplyResumesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAutoApplyResumesQuery = {
    __typename?: 'Query';
    jobSeekerProfile?:
        | {
              __typename?: 'JobSeekerProfilePayload';
              profile?:
                  | {
                        __typename?: 'JobSeekerProfile';
                        latestApply?:
                            | {
                                  __typename?: 'JobSeekerProfileLatestApplyPayload';
                                  resumeType?:
                                      | Types.JobSeekerProfileLatestAppliedResumeType
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        fileInformation: Array<{
                            __typename?: 'JobSeekerProfileFile';
                            id: string;
                            fileName?: string | null | undefined;
                            fileType?: Types.JobSeekerProfileFileType | null | undefined;
                            uploadTimestamp?: any | null | undefined;
                        }>;
                        resume: Array<{
                            __typename?: 'JobSeekerProfileResume';
                            id: string;
                            resumeType?: Types.JobSeekerProfileResumeType | null | undefined;
                            dateModified?: any | null | undefined;
                            firstName?: string | null | undefined;
                            lastName?: string | null | undefined;
                            phoneNumber?: string | null | undefined;
                            location?:
                                | {
                                      __typename?: 'JobSeekerProfileLocationType';
                                      formattedLocation?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                            educations: Array<{
                                __typename?: 'JobSeekerProfileEducation';
                                school?: string | null | undefined;
                                degree: Array<{
                                    __typename?: 'JobSeekerProfileDegree';
                                    degreeName?: string | null | undefined;
                                    field?: string | null | undefined;
                                }>;
                            }>;
                            workExperiences: Array<{
                                __typename?: 'JobSeekerProfileWorkExperience';
                                title?: string | null | undefined;
                                company?: string | null | undefined;
                            }>;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              selectedResumeType?: Types.SelectedResumeType | null | undefined;
              sqPastAnswerPrefillPreference?:
                  | Types.SqPastAnswerPrefillPreference
                  | null
                  | undefined;
          }
        | null
        | undefined;
    jobSeekerProfileDualResumesEnabled?:
        | { __typename?: 'JobSeekerProfileDualResumesEnabledPayload'; enabled: boolean }
        | null
        | undefined;
    jobSeekerResumes?:
        | {
              __typename?: 'JobSeekerResumesPayload';
              resumes: Array<{
                  __typename?: 'JobSeekerResumeBundle';
                  resumeId: string;
                  originalUploadedFile?:
                      | {
                            __typename?: 'JobSeekerResumeFile';
                            metadata: {
                                __typename?: 'JobSeekerProfileFile';
                                id: string;
                                fileName?: string | null | undefined;
                                fileType?: Types.JobSeekerProfileFileType | null | undefined;
                                uploadTimestamp?: any | null | undefined;
                            };
                        }
                      | null
                      | undefined;
                  pdfResumeFile?:
                      | { __typename?: 'JobSeekerResumeFile'; url: string }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export type DownloadFileResumeMutationVariables = Types.Exact<{
    fileId: Types.Scalars['ID']['input'];
}>;

export type DownloadFileResumeMutation = {
    __typename?: 'Mutation';
    createJobSeekerProfileResumeFileTempUrls?:
        | {
              __typename?: 'CreateJobSeekerProfileResumeFileTempUrlsPayload';
              pdfResumeUrl?: any | null | undefined;
          }
        | null
        | undefined;
};

export type CreateUploadResumeUrlMutationVariables = Types.Exact<{ [key: string]: never }>;

export type CreateUploadResumeUrlMutation = {
    __typename?: 'Mutation';
    createJobSeekerProfileUploadResumeFileTempUrl?:
        | {
              __typename?: 'CreateJobSeekerProfileUploadResumeFileTempUrlPayload';
              uploadURL: any;
              fileId: string;
          }
        | null
        | undefined;
};

export type AddJobSeekerProfileResumeFileMutationVariables = Types.Exact<{
    input: Types.AddJobSeekerProfileResumeFileInput;
}>;

export type AddJobSeekerProfileResumeFileMutation = {
    __typename?: 'Mutation';
    addJobSeekerProfileResumeFile?:
        | {
              __typename?: 'AddJobSeekerProfileResumeFilePayload';
              originalResumeFile?:
                  | { __typename?: 'JobSeekerProfileFile'; id: string }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export type DeleteResumeBundleMutationVariables = Types.Exact<{
    input: Types.DeleteResumeBundleInput;
}>;

export type DeleteResumeBundleMutation = {
    __typename?: 'Mutation';
    deleteResumeBundle?:
        | { __typename?: 'DeleteResumeBundlePayload'; resumeId: string }
        | null
        | undefined;
};

export type UpdateSelectedResumeTypeMutationVariables = Types.Exact<{
    input: Types.UpdateAutoApplyInput;
}>;

export type UpdateSelectedResumeTypeMutation = {
    __typename?: 'Mutation';
    updateAutoApply: {
        __typename?: 'UpdateAutoApplyPayload';
        selectedResumeType?: Types.SelectedResumeType | null | undefined;
    };
};

export const GetAutoApplyResumesDocument = gql`
    query GetAutoApplyResumes {
        jobSeekerProfile {
            profile {
                latestApply {
                    resumeType
                }
                fileInformation {
                    id
                    fileName
                    fileType
                    uploadTimestamp
                }
                resume {
                    id
                    resumeType
                    dateModified
                    firstName
                    lastName
                    phoneNumber
                    location {
                        formattedLocation
                    }
                    educations {
                        degree {
                            degreeName
                            field
                        }
                        school
                    }
                    workExperiences {
                        title
                        company
                    }
                }
            }
        }
        autoApplyInfo {
            selectedResumeType
            sqPastAnswerPrefillPreference
        }
        jobSeekerProfileDualResumesEnabled {
            enabled
        }
        jobSeekerResumes {
            resumes {
                resumeId
                originalUploadedFile {
                    metadata {
                        id
                        fileName
                        fileType
                        uploadTimestamp
                    }
                }
                pdfResumeFile {
                    url
                }
            }
        }
    }
`;

/**
 * __useGetAutoApplyResumesQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyResumesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoApplyResumesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAutoApplyResumesQuery,
        GetAutoApplyResumesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAutoApplyResumesQuery, GetAutoApplyResumesQueryVariables>(
        GetAutoApplyResumesDocument,
        options,
    );
}
export function useGetAutoApplyResumesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyResumesQuery,
        GetAutoApplyResumesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAutoApplyResumesQuery, GetAutoApplyResumesQueryVariables>(
        GetAutoApplyResumesDocument,
        options,
    );
}
export function useGetAutoApplyResumesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplyResumesQuery,
              GetAutoApplyResumesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetAutoApplyResumesQuery, GetAutoApplyResumesQueryVariables>(
        GetAutoApplyResumesDocument,
        options,
    );
}
export type GetAutoApplyResumesQueryHookResult = ReturnType<typeof useGetAutoApplyResumesQuery>;
export type GetAutoApplyResumesLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplyResumesLazyQuery
>;
export type GetAutoApplyResumesSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyResumesSuspenseQuery
>;
export type GetAutoApplyResumesQueryResult = Apollo.QueryResult<
    GetAutoApplyResumesQuery,
    GetAutoApplyResumesQueryVariables
>;
export const DownloadFileResumeDocument = gql`
    mutation DownloadFileResume($fileId: ID!) {
        createJobSeekerProfileResumeFileTempUrls(input: { id: $fileId }) {
            pdfResumeUrl
        }
    }
`;
export type DownloadFileResumeMutationFn = Apollo.MutationFunction<
    DownloadFileResumeMutation,
    DownloadFileResumeMutationVariables
>;

/**
 * __useDownloadFileResumeMutation__
 *
 * To run a mutation, you first call `useDownloadFileResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFileResumeMutation, { data, loading, error }] = useDownloadFileResumeMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDownloadFileResumeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DownloadFileResumeMutation,
        DownloadFileResumeMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<DownloadFileResumeMutation, DownloadFileResumeMutationVariables>(
        DownloadFileResumeDocument,
        options,
    );
}
export type DownloadFileResumeMutationHookResult = ReturnType<typeof useDownloadFileResumeMutation>;
export type DownloadFileResumeMutationResult = Apollo.MutationResult<DownloadFileResumeMutation>;
export type DownloadFileResumeMutationOptions = Apollo.BaseMutationOptions<
    DownloadFileResumeMutation,
    DownloadFileResumeMutationVariables
>;
export const CreateUploadResumeUrlDocument = gql`
    mutation CreateUploadResumeUrl {
        createJobSeekerProfileUploadResumeFileTempUrl {
            uploadURL
            fileId
        }
    }
`;
export type CreateUploadResumeUrlMutationFn = Apollo.MutationFunction<
    CreateUploadResumeUrlMutation,
    CreateUploadResumeUrlMutationVariables
>;

/**
 * __useCreateUploadResumeUrlMutation__
 *
 * To run a mutation, you first call `useCreateUploadResumeUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadResumeUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadResumeUrlMutation, { data, loading, error }] = useCreateUploadResumeUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateUploadResumeUrlMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateUploadResumeUrlMutation,
        CreateUploadResumeUrlMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateUploadResumeUrlMutation,
        CreateUploadResumeUrlMutationVariables
    >(CreateUploadResumeUrlDocument, options);
}
export type CreateUploadResumeUrlMutationHookResult = ReturnType<
    typeof useCreateUploadResumeUrlMutation
>;
export type CreateUploadResumeUrlMutationResult =
    Apollo.MutationResult<CreateUploadResumeUrlMutation>;
export type CreateUploadResumeUrlMutationOptions = Apollo.BaseMutationOptions<
    CreateUploadResumeUrlMutation,
    CreateUploadResumeUrlMutationVariables
>;
export const AddJobSeekerProfileResumeFileDocument = gql`
    mutation AddJobSeekerProfileResumeFile($input: AddJobSeekerProfileResumeFileInput!) {
        addJobSeekerProfileResumeFile(input: $input) {
            originalResumeFile {
                id
            }
        }
    }
`;
export type AddJobSeekerProfileResumeFileMutationFn = Apollo.MutationFunction<
    AddJobSeekerProfileResumeFileMutation,
    AddJobSeekerProfileResumeFileMutationVariables
>;

/**
 * __useAddJobSeekerProfileResumeFileMutation__
 *
 * To run a mutation, you first call `useAddJobSeekerProfileResumeFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobSeekerProfileResumeFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobSeekerProfileResumeFileMutation, { data, loading, error }] = useAddJobSeekerProfileResumeFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddJobSeekerProfileResumeFileMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AddJobSeekerProfileResumeFileMutation,
        AddJobSeekerProfileResumeFileMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        AddJobSeekerProfileResumeFileMutation,
        AddJobSeekerProfileResumeFileMutationVariables
    >(AddJobSeekerProfileResumeFileDocument, options);
}
export type AddJobSeekerProfileResumeFileMutationHookResult = ReturnType<
    typeof useAddJobSeekerProfileResumeFileMutation
>;
export type AddJobSeekerProfileResumeFileMutationResult =
    Apollo.MutationResult<AddJobSeekerProfileResumeFileMutation>;
export type AddJobSeekerProfileResumeFileMutationOptions = Apollo.BaseMutationOptions<
    AddJobSeekerProfileResumeFileMutation,
    AddJobSeekerProfileResumeFileMutationVariables
>;
export const DeleteResumeBundleDocument = gql`
    mutation DeleteResumeBundle($input: DeleteResumeBundleInput!) {
        deleteResumeBundle(input: $input) {
            resumeId
        }
    }
`;
export type DeleteResumeBundleMutationFn = Apollo.MutationFunction<
    DeleteResumeBundleMutation,
    DeleteResumeBundleMutationVariables
>;

/**
 * __useDeleteResumeBundleMutation__
 *
 * To run a mutation, you first call `useDeleteResumeBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResumeBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResumeBundleMutation, { data, loading, error }] = useDeleteResumeBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteResumeBundleMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteResumeBundleMutation,
        DeleteResumeBundleMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<DeleteResumeBundleMutation, DeleteResumeBundleMutationVariables>(
        DeleteResumeBundleDocument,
        options,
    );
}
export type DeleteResumeBundleMutationHookResult = ReturnType<typeof useDeleteResumeBundleMutation>;
export type DeleteResumeBundleMutationResult = Apollo.MutationResult<DeleteResumeBundleMutation>;
export type DeleteResumeBundleMutationOptions = Apollo.BaseMutationOptions<
    DeleteResumeBundleMutation,
    DeleteResumeBundleMutationVariables
>;
export const UpdateSelectedResumeTypeDocument = gql`
    mutation UpdateSelectedResumeType($input: UpdateAutoApplyInput!) {
        updateAutoApply(input: $input) {
            selectedResumeType
        }
    }
`;
export type UpdateSelectedResumeTypeMutationFn = Apollo.MutationFunction<
    UpdateSelectedResumeTypeMutation,
    UpdateSelectedResumeTypeMutationVariables
>;

/**
 * __useUpdateSelectedResumeTypeMutation__
 *
 * To run a mutation, you first call `useUpdateSelectedResumeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelectedResumeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelectedResumeTypeMutation, { data, loading, error }] = useUpdateSelectedResumeTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSelectedResumeTypeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateSelectedResumeTypeMutation,
        UpdateSelectedResumeTypeMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateSelectedResumeTypeMutation,
        UpdateSelectedResumeTypeMutationVariables
    >(UpdateSelectedResumeTypeDocument, options);
}
export type UpdateSelectedResumeTypeMutationHookResult = ReturnType<
    typeof useUpdateSelectedResumeTypeMutation
>;
export type UpdateSelectedResumeTypeMutationResult =
    Apollo.MutationResult<UpdateSelectedResumeTypeMutation>;
export type UpdateSelectedResumeTypeMutationOptions = Apollo.BaseMutationOptions<
    UpdateSelectedResumeTypeMutation,
    UpdateSelectedResumeTypeMutationVariables
>;
